var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 174,
    viewBox: "0 0 175 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7272_50465)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7272_50465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 175,
    height: 174
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9634 174C136.012 174 174.963 135.049 174.963 87C174.963 38.9512 136.012 0 87.9634 0C39.9146 0 0.963379 38.9512 0.963379 87C0.963379 135.049 39.9146 174 87.9634 174Z",
    fill: "#83BB26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7272_50465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 174C136.049 174 175 135.049 175 87C175 38.9512 136.049 0 88 0C39.9512 0 1 38.9512 1 87C1 135.049 39.9512 174 88 174Z",
    fill: "#FAAB35"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0895 87.1303C28.0895 120.763 55.4522 148.126 89.0852 148.126V70.7241L28.0895 87.1303Z",
    fill: "#D4EEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0855 70.7241V148.126C122.719 148.126 150.081 120.763 150.081 87.1303L89.0855 70.7241Z",
    fill: "#15888A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.081 87.1303C150.081 53.4969 122.719 26.1343 89.0855 26.1343V87.1303H150.081Z",
    fill: "#26ACAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0855 26.1343C55.4522 26.1343 28.0895 53.4969 28.0895 87.1303H89.0852V26.1343H89.0855Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.583 87.1303C119.583 120.763 105.902 148.126 89.0855 148.126L72.6793 74.8256H104.334L119.583 87.1303Z",
    fill: "#26ACAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0855 26.1343C105.902 26.1343 119.583 53.4969 119.583 87.1303H76.7808L89.0855 26.1343Z",
    fill: "#86DBDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5876 87.1303C58.5876 120.763 72.2688 148.126 89.0855 148.126V87.1303L73.8364 74.8256L58.5876 87.1303Z",
    fill: "#86DBDE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0855 26.1343C72.2688 26.1343 58.5876 53.4969 58.5876 87.1303H89.0855V26.1343Z",
    fill: "#D4EEEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136.148,
    y: 106.663,
    width: 14.2843,
    height: 44.06,
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.674 100.307C138.904 94.5643 147.173 94.5643 150.403 100.307L173.98 142.221C177.148 147.854 173.078 154.813 166.615 154.813H119.462C112.999 154.813 108.929 147.854 112.097 142.221L135.674 100.307ZM147.263 142.139C147.263 144.472 145.372 146.364 143.038 146.364C140.705 146.364 138.813 144.472 138.813 142.139C138.813 139.806 140.705 137.914 143.038 137.914C145.372 137.914 147.263 139.806 147.263 142.139ZM143.038 108.34C140.705 108.34 138.813 110.231 138.813 112.564V125.239C138.813 127.573 140.705 129.464 143.038 129.464C145.372 129.464 147.263 127.573 147.263 125.239V112.564C147.263 110.231 145.372 108.34 143.038 108.34Z",
    fill: "#FF7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7272_50465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 174,
    fill: "white",
    transform: "translate(0.963379)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIcon);
export default __webpack_public_path__ + "static/media/connectionIcon.5eba7ea8.svg";
export { ForwardRef as ReactComponent };